<template>
  <b-dropdown size="sm" :text="task.htmlPriority.name" :variant="priorityBtnVariant">
    <b-dropdown-item :key="priority.value" v-for="priority in priorities" :disabled="priority.value === task.priority" @click="changePriority(priority.value)">{{priority.name}}</b-dropdown-item>
  </b-dropdown>
</template>

<script>
 import bDropdown from 'bootstrap-vue/es/components/dropdown/dropdown';
 import bDropdownItem from 'bootstrap-vue/es/components/dropdown/dropdown-item';
 import {showError} from 'perform-base/js/flashes';
 import axios from 'axios';

 export default {
   data() {
     return {
       priorities: [
         {name: 'Low', value: 0},
         {name: 'Normal', value: 1},
         {name: 'High', value: 2},
       ],
       task: this.initialTask,
     };
   },

   props: [
     'initialTask',
   ],

   components: {
     bDropdown,
     bDropdownItem,
   },

   computed: {
     priorityBtnVariant() {
       return this.task.htmlPriority.class;
     }
   },

   methods: {
     changePriority(priority) {
       axios.post(`/api/tasks/set-priority/${this.task.id}/${priority}`)
            .then(response => {
              this.task = response.data.task;
            })
            .catch((error) => {
              showError(
                error.response.status === 403 ?
                'Permission denied. Only the task author or project owner can change the task priority.' :
                'An error occurred changing the task priority. Try again later.'
              );
            });
     },
   }
 }
</script>



// WEBPACK FOOTER //
// assets/js/components/TaskPrioritySwitcher.vue